module.exports = __webpack_public_path__ + "img/1.d28aa7a0.svg";